import React from 'react';

const Home = () => (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Welcome to Songer Consulting</h1>
        <div className="space-y-6">
            <p className="text-lg">
                At Songer Consulting, we pride ourselves on our comprehensive expertise
                across the entire software development lifecycle. Our seasoned professionals
                excel in every phase, from initial requirements gathering and stakeholder
                consultations to final delivery and beyond.
            </p>
            <p className="text-lg">
                Our developers are distinguished not only by their technical prowess but
                also by their exceptional communication skills. This unique combination
                allows us to bridge the gap between complex business requirements and
                technical solutions effectively.
            </p>
            <p className="text-lg">With a proven track record of successful collaborations with international clients, we have conducted
                workshops and led projects across Europe and the United States. Our global experience enhances our
                ability to adapt to diverse business cultures and requirements. We take pride in our consistent track
                record of delivering high-quality solutions that not only meet but exceed our clients' expectations.
            </p>
            <p className="text-lg">Whether you're a startup looking to bring an innovative idea to life or an established enterprise seeking
                to modernize your systems, Songer Consulting is equipped to guide you through every step of the journey.
                Our process-driven approach, illustrated below, ensures transparency, efficiency, and success in every
                project we undertake.
            </p>
        </div>
    </div>
);
export default Home;
  